import { Util } from "utils";
import { KeyType } from "types/common/CommonType";

export const onKeyPressListener = (
  key: keyof KeyType,
  callback: () => void
) => {
  const onPressESCKeyCheck = (event: KeyboardEvent) => {
    Util.handleKeyPress(event, key, () => callback());
  };

  const keydownListener = (e: KeyboardEvent) => onPressESCKeyCheck(e);
  document.addEventListener("keydown", keydownListener);
  return () => {
    document.removeEventListener("keydown", keydownListener);
  };
};
